import { useEffect, useState } from "react";
import { useParams, Link as RouterLink } from "react-router-dom";
import styles from "./TodayRequestList.module.css";
import { styled } from "@mui/material/styles";
import { Card, CardContent, CardActions, Typography, Box, Button, Snackbar, Alert } from "@mui/material";
import { CameraAltRounded } from "@mui/icons-material";
import axios from "axios";
import Loader from "../components/Loader";
import { authData } from "../components/GetAuth";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const DriverItemDetails = () => {
  const bookingId = useParams();
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [loading, setLoading] = useState(true);
  const [bookingData, setBookingData] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");

  useEffect(() => {
    setLoading(true);
    axios(process.env.REACT_APP_API_URL + "v1/driver/booking-item-details/" + bookingId?.id, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setLoading(false);
        let bookingDataTemp = response.data.data;
        setBookingData(bookingDataTemp);
      } else {
        setLoading(false);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }, [API_TOKEN, bookingId]);

  const FileUpload = (event, id) => {
    const formData = new FormData();
    let image = event.target.files[0];
    formData.append("image", image);
    formData.append("booking_id", bookingId?.id);
    formData.append("booking_product_id", id);
    let postData = formData;

    axios.post(process.env.REACT_APP_API_URL + "v1/driver/upload-image", postData, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("success");
      }
    }).catch((error) => {
      setLoading(false);
    });
  }


  return (<>
    <div className={`${styles.MainDiv}`}>
      <Loader open={loading} setOpen={setLoading.bind(this)} />
      <div className={`${styles.PageTitleWrap}`}>
        <p className={`${styles.PageTitle}`}>Item Details</p>
      </div>
      <div className={`${styles.MainCard}`}>
        {bookingData?.products?.map((item, index) => {
          return (<Box sx={{ minWidth: 275 }}>
            <Card variant="outlined" key={item?.id}>
              <CardContent>
                <Typography variant="h5" component="div">{item?.product_title}</Typography>
                <p className={`${styles.UserProDeList}`}>
                  <span>Amount to Pay:</span>
                  {item?.sub_amount}
                </p>
                <p className={`${styles.UserProDeList}`}>
                  <span>{item?.is_fragile ? "Fragile" : ""}</span>
                </p>
                <Button component="label" role={undefined} variant="contained" tabIndex={-1} className={`SubmitBU`} startIcon={<CameraAltRounded />}>
                  <VisuallyHiddenInput type="file" accept="image/png, image/jpeg" onChange={(event) => FileUpload(event, item?.id)} name="image" />
                </Button>
              </CardContent>
            </Card>
          </Box>);
        })}

        <Box sx={{ minWidth: 275 }}>
          <Card variant="outlined">
            <CardActions>
              <RouterLink size="small" to={`/driver/item-edit/${bookingData?.id}`} as={Button} className={`SubmitBU`}>Add Row</RouterLink>
            </CardActions>
          </Card>
        </Box>
        <Box sx={{ minWidth: 275 }}>
          <Card variant="outlined">
            <CardContent>
              <p className={`${styles.UserProDeList}`}>
                <span>Total Amount:</span>
                <span>&pound; {parseFloat(bookingData?.amount).toFixed(2)}</span>
              </p>
            </CardContent>
          </Card>
        </Box>

        <div className={`FormButtonArea`}>
          <RouterLink as={Button} to={`/driver/address-details/${bookingId?.id}`} className={`CancelBU`}>Back</RouterLink>
          <RouterLink to={`/driver/payment-details/${bookingData?.id}`} as={Button} className={`SubmitBU`}>Proceed</RouterLink>
        </div>
      </div>
    </div>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
}

export default DriverItemDetails;